var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dashboard-sidebar"},[(_vm.selectedWidget)?_c('WidgetSettings',{attrs:{"dashboard":_vm.dashboard,"widget":_vm.selectedWidget}}):_c('EmptyDashboardSidebar')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }